import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';
import './style.css';

import P_1 from '../../assets/press/Press-1-1.png';
import P_1_2 from '../../assets/press/Press-1-2.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_4 from '../../assets/press/Press-5-1.jpg';

export default function PressPage1() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_2,
      title:
        '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
      link: ROUTE_NAMES.PRESS2,
    },
    {
      image: P_3,
      title:
        'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
      link: ROUTE_NAMES.PRESS3,
    },
    {
      image: P_4,
      title:
        'The Future of Luxury Real Estate: An Exclusive Interview with Gevorg Shahbazyan, Visionary Founder of Starlife Group',
      link: ROUTE_NAMES.PRESS4,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal
          Highway, Hollywood, FL, 33020
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_1} alt='press-image' />
        <h2 className='press-page-title'>
          Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway,
          Hollywood, FL, 33020
        </h2>
        <span className='author-name'>By Colt Dodd</span>
        <span className='author-name'>Dec 7, 2024</span>
        <Link
          to={
            'https://floridayimby.com/2024/12/construction-starts-on-21-hollywood-at-2100-n-federal-highway-hollywood-fl-33020.html'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p>
            21 Hollywood, a mixed-use venture Florida YIMBY covered last year,
            has officially broken ground in Broward County. The 13-story venture
            will comprise 200 apartments (18 of which are penthouses), along
            with 10,000 square feet of retail and 301 parking spots, averaging
            to about 1.51 per unit.
          </p>
          <p>
            The amenity-rich community will include a swimming pool deck,
            fitness center, movie room, and dog park. Construction was initially
            anticipated to start this summer. Starlife Group is the developer;
            its general contracting arm, Starlife Builders, is working on the
            complex.
          </p>
          <img src={P_1_2} alt='press-image' />
          <p>
            The former acquired the 1.48-acre build site for $6.5 million in
            2023, averaging about $542 per square foot. The now-vacant build
            site, which lies across from South Broward High School, once hosted
            a 6,000-square-foot commercial building. Kobi Karp Architecture
            designed 21 Hollywood.
          </p>
          <p>
            The Miami-based firm also designed the Residences at Shell Bay, a
            multi-million-dollar project that will feature both condos and hotel
            rooms. Delivery is slated for 2027—the same year 21 Hollywood is
            planned to reach completion. Kobi Karp also designed a 420-foot-high
            luxury condo in South Beach.
          </p>
          <p>
            21 Hollywood is currently undergoing construction at 2100 N. Federal
            Highway, Hollywood, FL, 33020, in Broward County.
          </p>
          <iframe
            title='Google Map Location'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.099510641962!2d-80.1462619250823!3d26.03029989745509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abaa6d3f33b9%3A0xc2c60b28d83d4594!2zMjEwMCBOIEZlZGVyYWwgSHd5LCBIb2xseXdvb2QsIEZMIDMzMDIwLCDQodCo0JA!5e0!3m2!1sru!2sam!4v1747902513561!5m2!1sru!2sam'
            width='100%'
            height='400'
            style={{ border: 0 }}
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
